import { Component, Input, OnChanges } from "@angular/core"
import { Colors } from "../../../models/colors.model"
import { FeaturedAsset } from "../../../models/featuredAsset.model"
import { ITSImage } from "../../../models/itsImage.model"
import { Language } from "../../../models/language.model"
import { MuxDataModel } from "../../../models/muxData.model"
import { Caption, VideoMedia, VideoMediaFile } from "../../../models/resource/media"
import { ColorCodeService } from "../../../services/color-code.service"
import { GtmVideoJsInfo } from "../../../utils/types"

@Component({
    selector: "app-collection-description",
    templateUrl: "./collection-description.component.html",
    styleUrls: ["./collection-description.component.scss"],
    standalone: false,
})
export class CollectionDescriptionComponent implements OnChanges {
    @Input() public displayShortDescription: boolean = true
    @Input() public styles: Colors = new Colors({})
    @Input() public isVideo: boolean = true
    @Input() public featuredAsset: FeaturedAsset = new FeaturedAsset({})
    public video: VideoMedia = null
    public muxData: MuxDataModel
    protected posterImageURL: string = null
    public gtmVideoJsInfo: GtmVideoJsInfo

    constructor(private colorCodeService: ColorCodeService) {}

    public ngOnChanges() {
        this.isVideo = false
        if (this.featuredAsset.posterImage) {
            this.posterImageURL = this.featuredAsset.posterImage.url
        } else {
            this.posterImageURL = null
        }
        if (this.featuredAsset.mediaType === "Video") {
            this.isVideo = true
            const captions: Caption[] = [
                new Caption(this.featuredAsset.media[0].caption, Language.EN),
            ]
            const chapters: string = this.featuredAsset.media[0].chapters
            const is360: boolean = this.featuredAsset.media[0].is_360
            const videoFiles = this.featuredAsset.media.map((media) => {
                return new VideoMediaFile(
                    media.has_georestriction,
                    media.role,
                    media.url,
                    media.type,
                    media.primary
                )
            })
            this.video = new VideoMedia(
                Language.EN,
                new ITSImage(
                    this.featuredAsset.posterImage.url,
                    this.featuredAsset.posterImage.alt_text
                ),
                null,
                null,
                null,
                null,
                captions,
                videoFiles,
                is360,
                chapters
            )
            this.muxData = new MuxDataModel(
                this.featuredAsset.title,
                Language.EN,
                this.featuredAsset.mediaType
            )
            this.gtmVideoJsInfo = {
                title: this.featuredAsset.title,
                guid: "",
                type: this.featuredAsset.mediaType,
            }
        }
    }
    public getColor() {
        if (this.styles.isEnabled) {
            return {
                background: this.styles.colorBkgd,
                color: this.styles.colorText,
            }
        }
        return {
            background: this.colorCodeService.collectionColors.defaultBackgroundColor,
            color: this.colorCodeService.collectionColors.defaultTextColor,
        }
    }
}
